import img_glasvordach_pfosten from './auswahl/glasvordach_pfosten.svg';

export const glasvordach_pfosten =
    {
        category: 'Glasvordach mit Pfosten',
        product_img: img_glasvordach_pfosten,
        titel: 'Glasvordach mit Pfosten',
        price: 338,
        wrapper: [{wrapper1: 0, wrapper2: 0, wrapper3: 0}],
        steps: [
            [[false], [false], [false], [false]],
            {
                visited: [0],
                active_steps: []
            }
        ],
        dimensions: [
            {
            width: '',
            width_param: '90',
            height: '',
            height_param: '70 - 179'
          },
        ],
        glasart: '',
        pfosten: '',
        data_description: [
            {
                image: '',
                file: '',
                description: '',
                isUploadData: false
            }
        ],
        allVisitedSteps: false,
        is_merkliste: false
    }
